import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';
import { ExpertHubStateFragmentFragmentDoc } from '../fragments/expertHubState.fragment.generated';

const defaultOptions = {} as const;
export type ExpertHubStateQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ExpertHubStateQuery = {
  __typename?: 'Query';
  expertHubState: {
    __typename?: 'ExpertHubStateType';
    onboardingStep?: string | null;
    onboardingMode?: Types.OnboardingModeEnum | null;
    source?: Types.ExpertHubSourceEnum | null;
    onboardingFinishedAt?: any | null;
    extractionState?: Types.ExpertHubExtractionStateEnum | null;
    cvReuploadAvailable: boolean;
  };
};

export const ExpertHubStateDocument = gql`
  query expertHubState {
    expertHubState {
      ...ExpertHubStateFragment
    }
  }
  ${ExpertHubStateFragmentFragmentDoc}
`;

/**
 * __useExpertHubStateQuery__
 *
 * To run a query within a React component, call `useExpertHubStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertHubStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertHubStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertHubStateQuery(
  baseOptions?: Apollo.QueryHookOptions<ExpertHubStateQuery, ExpertHubStateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpertHubStateQuery, ExpertHubStateQueryVariables>(
    ExpertHubStateDocument,
    options,
  );
}
export function useExpertHubStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExpertHubStateQuery, ExpertHubStateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpertHubStateQuery, ExpertHubStateQueryVariables>(
    ExpertHubStateDocument,
    options,
  );
}
export function useExpertHubStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExpertHubStateQuery, ExpertHubStateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExpertHubStateQuery, ExpertHubStateQueryVariables>(
    ExpertHubStateDocument,
    options,
  );
}
export type ExpertHubStateQueryHookResult = ReturnType<typeof useExpertHubStateQuery>;
export type ExpertHubStateLazyQueryHookResult = ReturnType<typeof useExpertHubStateLazyQuery>;
export type ExpertHubStateSuspenseQueryHookResult = ReturnType<
  typeof useExpertHubStateSuspenseQuery
>;
export type ExpertHubStateQueryResult = Apollo.QueryResult<
  ExpertHubStateQuery,
  ExpertHubStateQueryVariables
>;
export function refetchExpertHubStateQuery(variables?: ExpertHubStateQueryVariables) {
  return { query: ExpertHubStateDocument, variables };
}
